import { dateISOIn } from 'Data/format.js'

export function getDateOfBirths(value) {
  // eslint-disable-next-line compat/compat
  return Object.values(value)
    .map(item => dateISOIn(item))
    .join(', ')
}
